import { PageViewEvent } from '@shopify/events';

function dispatchPageViewEvent() {
  /** @type {HTMLElement | null} */
  const templateElement = document.querySelector('main[data-template]');
  const template = templateElement?.dataset.template || '';

  document.dispatchEvent(
    new PageViewEvent({
      page: {
        template,
        title: document.title,
        url: window.location.href,
      },
    })
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dispatchPageViewEvent, { once: true });
} else {
  dispatchPageViewEvent();
}
